import { Box, colors, Typography, styled } from '@mui/material';
import {
  ContentContainer,
  Kicker,
  SectionH2,
  SectionHead,
} from '~/components/HomepageV3/styles';

interface FaqItem {
  question: string;
  answer: string;
}

export const FAQS: FaqItem[] = [
  {
    question: 'What is NerdyData?',
    answer:
      'NerdyData is a search engine for website source code. It crawls millions of live domains and lets you find every website using a specific technology, JavaScript library, HTML pattern, cookie, or HTTP header.',
  },
  {
    question: 'What can you search for on NerdyData?',
    answer:
      'You can search by technology name (e.g. "Shopify", "Klaviyo"), raw code snippets, script URLs, cookie names, or HTTP headers. Results include company info, estimated ad spend, emails, and LinkedIn profiles for each matching domain.',
  },
  {
    question: 'Who uses NerdyData?',
    answer:
      'Sales teams use it to build prospect lists by tech stack. Marketers use it to size markets and benchmark adoption. Security researchers use it to track websites using specific code fingerprints or vulnerable versions of software.',
  },
  {
    question: 'How does NerdyData find websites using a technology?',
    answer:
      'NerdyData runs a proprietary crawler that fully renders each page — including JavaScript — and indexes the resulting source code, cookies, headers, and network requests. This means it can detect client-side scripts, tag managers, and dynamically injected code that standard crawlers miss.',
  },
];

export const WhatIsSection = () => (
  <WhatIsSectionRoot>
    <ContentContainer sx={{ py: 12 }}>
      <SectionHead>
        <Kicker>About NerdyData</Kicker>
        <SectionH2>
          The search engine for source-code and technographics.
        </SectionH2>
      </SectionHead>

      <FaqGrid>
        {FAQS.map(({ question, answer }) => {
          return (
            <FaqCard key={question}>
              <FaqQuestion component="h3">{question}</FaqQuestion>
              <FaqAnswer>{answer}</FaqAnswer>
            </FaqCard>
          );
        })}
      </FaqGrid>
    </ContentContainer>
  </WhatIsSectionRoot>
);

const WhatIsSectionRoot = styled(Box)`
  border-top: 1px solid ${colors.grey[200]};
`;

const FaqGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

const FaqCard = styled(Box)`
  padding: 28px;
  border: 1px solid ${colors.grey[200]};
  border-radius: 16px;
  background: #fff;
`;

const FaqQuestion = styled(Typography)`
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: ${colors.grey[900]};
  margin: 0 0 10px;
` as typeof Typography;

const FaqAnswer = styled(Typography)`
  font-size: 15px;
  line-height: 1.6;
  color: ${colors.grey[600]};
  margin: 0;
` as typeof Typography;
